import { CellResizeContext } from './Contexts';
import { useContext } from 'react';
import { DragGeometryContext } from './MouseDragProvider';


export default function HorizontallyTranslatableGridContainer({children}){

  //let { cellResizeInfo } = useContext(CellResizeContext);

  let dragContext = useContext(DragGeometryContext);

  let tx = 0;

  if( dragContext ){
  let { start, end, info } = dragContext;

    if( info?.leftResize ){

      let startX = start[0];
      let currentX = end[0];

      let delta = currentX - startX;
      tx = delta;
    }
  }


  

  

  return (

    <div 
          class="full-width"
          style={{
            top:25,
            transform:'translate('+tx+'px,0)',
            display:'flex',
            //gridTemplateColumns:'100px auto 100px',
          }}>
      {children}
    </div>
  )


}
